<template>
  <vs-dropdown vs-trigger-click
               class="cursor-pointer hover:bg-primary-a20 rounded disabled:cursor-not-allowed"
               :disabled="disabled">

    <div class="flex justify-center">
      <vs-icon icon="more_horiz" :class="disabled ? 'text-gray' : 'text-primary'" size="small"></vs-icon>
    </div>

    <vs-dropdown-menu class="mt-1 w-64 test-add-menu-items">
      <slot></slot>
    </vs-dropdown-menu>

  </vs-dropdown>
</template>

<script>
export default {
  name: 'AddBubbleMenu',

  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  }
}
</script>
